module.exports = __webpack_public_path__ + "static/media/moh-logo.2e8342a7.png";